import { api } from './api';

const once = (key) => {
  try {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, '1');
  } catch { /* private mode */ }
  return true;
};

export const trackSponsor = (slug, kind, surface, count = 1) => {
  if (!slug || count < 1) return;
  if (kind === 'impression' && !once(`dealgo_sp_${slug}_${surface}`)) return;
  api.post(`/live/${slug}/sponsor/track`, { kind, surface, count: Math.min(50, count) }).catch(() => {});
};
